import { render, staticRenderFns } from "./detailsFinancesByParent.vue?vue&type=template&id=5db83560&"
import script from "./detailsFinancesByParent.vue?vue&type=script&lang=js&"
export * from "./detailsFinancesByParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports